import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function Modal({ children, handleClose }) {
  const modalRef = useRef(null);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleClose]);

  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.focus();
    }
  }, []);

  const modalContent = (
    <div className="fixed inset-0 z-[90]">
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-[1px]"
        onClick={handleClose}
      />
      <div className="absolute inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 sm:p-6">
          <motion.div
            ref={modalRef}
            role="dialog"
            aria-modal="true"
            tabIndex={-1}
            className="relative z-[95] flex w-full max-w-3xl flex-col outline-none"
            initial={{ opacity: 0, y: 12, scale: 0.985 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.18 }}
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="mb-2 self-end rounded-full bg-white/10 px-3 py-1 text-xl text-white transition hover:bg-white/20"
              onClick={handleClose}
              aria-label="Затвори модала"
            >
              &#x2715;
            </button>
            <div className="overflow-visible rounded-2xl bg-white p-2 shadow-2xl">
              {children}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}
